/**
 * 개발 환경(development)에서만 콘솔에 로그를 출력하는 유틸리티 함수들입니다.
 * React 프로젝트의 `process.env.NODE_ENV` 값을 확인하여 동작합니다.
 * 
 * 사용법:
 * import { devLog, devWarn, devError } from 'utils/logger';
 * 
 * devLog('개발용 로그 메시지입니다.', { data: 'some-data' });
 * devWarn('개발용 경고 메시지입니다.');
 * devError('개발용 에러 메시지입니다.');
 */

/**
 * 개발 환경에서만 동작하는 `devLog`
 * @param {...any} args - `devLog`에 전달할 인자들
 */
export const devLog = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

/**
 * 개발 환경에서만 동작하는 `console.warn`
 * @param {...any} args - `console.warn`에 전달할 인자들
 */
export const devWarn = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn(...args);
  }
};

/**
 * 개발 환경에서만 동작하는 `console.error`
 * @param {...any} args - `console.error`에 전달할 인자들
 */
export const devError = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(...args);
  }
}; 